import { Inject, Injectable, TemplateRef } from '@angular/core';
import { ValidatorFn, Validators } from '@angular/forms';
import { DataTypes } from '../enums/DataType';
import { ControlTypes } from '../enums/ControlTypes';
import { IControls } from './IControls';
import { IColumns } from './IColumns.interface';
import { ControlBase } from './ControlBase';


export interface IField {

  FieldName: string;
  DataType: DataTypes;
  IsEditable?: boolean | undefined;
  IsFilterable?: boolean | undefined;
  DefaultValue?: string | number | null | Date | boolean | undefined;
  Width?: number;
  Validators?: ValidatorFn | null | Array<ValidatorFn>;
  IsPrimaryKey?: boolean;
  IsSubmitExcluded?: boolean | undefined;
  removeNegativeTransform?: boolean;
  ConditionalCellStyleFn?: Function;
};


export interface IEntity {
  EntityName: string;
  Fields: IField[];
  ODATAAPIURL?: string;
  POSTAPIURL?: string | undefined;
  PUTAPIURL?: string | undefined;
  DELETEAPIURL?: string | undefined;
  FieldsToExecludeFromInsertUpdate?: IField[]
};

export class BIEntity implements IEntity {
  EntityName: string;
  Fields: IField[];
  ODATAAPIURL?: string;
  POSTAPIURL?: string | undefined;
  PUTAPIURL?: string | undefined;
  DELETEAPIURL?: string | undefined;
  FieldsToExecludeFromInsertUpdate?: IField[];
  constructor() {
    this.EntityName = "";
    this.Fields = [];
  }
}


function CopyCommonProperties(Source:any, Destination:any) {
  const commonKeys = Object.keys(Source).filter((key) => Destination.hasOwnProperty(key));
  commonKeys.forEach((key)=>{
    Destination[key]=Source[key];
  });
}
export abstract class IBIControl extends ControlBase {
  Group?: string;
  DomID?: string | undefined;
  FieldName!: string;
  DisplayName?: string;
  controlType!: ControlTypes;
  IsEditable?: boolean;
  IsFilterable?: boolean;
  IsNumber2Boolean?:Boolean;
  DefaultValue?: string | number | null | Date | boolean;
  viewCellStyle?: string;
  IsVisible?: boolean;
  Width?: number;
  Mask?: string;
  lookupTemplate?: {
    Key: string | undefined;
    ID: string | undefined;
    Description?: string;
    AfterLoad?: Function;
    BeforeLoad?: Function;
    OnClose?: Function;
    OnOpen?: Function;
    OnOpenSecondLkp?: Function;
    ReturnedValueEmitter?: Function;
    DataSource: any;
    hasSecondLkp?: boolean;
    route?:string;
    Title?:string;
    hasSelection?:boolean
  };
  dropDownTemplate?: {
    value: string;
    text: string;
    list: any[];
    SuggestedList?: any[];
    OnValueChange?: Function;
    OnselectionChange?: Function;
    OnOpen?:Function;
    OnFocus?:Function;
  }
  Validators?: ValidatorFn | null | Array<ValidatorFn>;
  colNumber!: number;
  rowNumber!: number;
  ShowinOverviewGrid?: boolean;
  ClickableText?: string;
  ModalTitle?: string;
  checkboxTemplate?: {
    HasSelectAll: boolean | undefined
    HasSelectAllLabel?: boolean | undefined
  }
  imgs?: { image: string, showOnValue: number, text?:string }[];
  LogImageTemplate?: {
    filterList: { image: string, showOnValue: number, text?:string } [];
  };
  TextAfterInput?: string;
  TemplateRef?: TemplateRef<any>;
  Precision?:number
}

export class BIEntity_Controls {
  protected DBTable!: BIEntity;
  protected ControlList: IControls[] = [];
  protected groupedControlList: { group: string, Control: IControls }[] = [];
  protected BIControlList: IBIControl[] = [];
  protected OverviewAndFromGroupColumns: IColumns[] = [];
  protected charWidthinPixels: number = 8;
  defaultColWidth: number = 10;

  public getDatasourceColumns(): {
    Name: string,
    DataType: DataTypes,
  }[] {
    /*return this.ControlList.map( field =>
      {
          return {Name: field.Name , DataType: field.DataType};

      }
      )
    */
    return this.DBTable.Fields.map(field => {
      return { Name: field.FieldName, DataType: field.DataType };

    }
    );

  }
  public setFieldControlProperties(inputContol: IBIControl) {
    let calculatedWidth: number = 20;
    let CalculatedWidthPct: number = 100;
    const maxWidthPct = 100;
    const numberFieldMaxWidth = 20;
    const displayMaxWidth = 35;
    const maxColWidth = 50;
    let control: IControls =
      { Name: "", controlType: ControlTypes.Text, colNumber: 0, rowNumber: 0, DomID: "", DisplayName: "", IsVisible: true  };
    let Column: IColumns =
    {
      Name: "", DisplayName: "", DataType: DataTypes.Text,
      controlType: ControlTypes.Text, DefaultValue: 0,
      DomID: "", IsEditable: false, IsFilterable: false, IsVisible: false,
      Validators: null, viewCellStyle: ""
    };

    if(inputContol.controlType==ControlTypes.CheckBox &&
      this.DBTable.Fields.find(x=>x.FieldName==inputContol.FieldName  && x.DataType==DataTypes.NUMERIC ))
      {
        Column.IsNumber2Boolean = inputContol.IsNumber2Boolean=true;
      }
    //  CopyCommonProperties(inputContol,control);
     // CopyCommonProperties(inputContol,Column);
    if (inputContol.controlType === ControlTypes.Title || inputContol.controlType === ControlTypes.Empty) {
      control.Name = inputContol.FieldName;
      control.DisplayName = inputContol.DisplayName ?? inputContol.FieldName;
      control.DomID = inputContol.DomID ?? "BICNTRL_" + inputContol.FieldName;
      control.DataType = DataTypes.Text;
      control.IsEditable = false;
      control.IsFilterable = false;
      control.colNumber = inputContol.colNumber;
      control.rowNumber = inputContol.rowNumber;
      control.controlType = inputContol.controlType;

    }
    else {
      let FieldDetails: IField;
      FieldDetails = this.DBTable.Fields.find(field => {
        return inputContol.FieldName.toLowerCase() === field.FieldName.toLowerCase();
      }) as IField;
      if (FieldDetails && FieldDetails !== null && FieldDetails !== undefined) {
        control.Name = FieldDetails.FieldName;
        control.DisplayName = inputContol.DisplayName ?? FieldDetails.FieldName;
        control.DomID = inputContol.DomID ?? "BICNTRL_" + FieldDetails.FieldName;
        control.DataType = FieldDetails.DataType;
        control.IsEditable = inputContol.IsEditable ?? FieldDetails.IsEditable;
        control.IsFilterable = inputContol.IsFilterable ?? FieldDetails.IsFilterable;
        control.Mask = inputContol.Mask;
        control.Width = inputContol.Width ?? FieldDetails.Width ?? numberFieldMaxWidth;
        control.colNumber = inputContol.colNumber;
        control.rowNumber = inputContol.rowNumber
        control.controlType = inputContol.controlType;
        control.dropDownTemplate = inputContol.dropDownTemplate;
        control.lookupTemplate = inputContol.lookupTemplate;
        control.viewCellStyle = inputContol.viewCellStyle;
        control.Validators = inputContol.Validators ?? FieldDetails.Validators;
        control.DefaultValue = inputContol.DefaultValue ?? FieldDetails.DefaultValue ?? null;
        control.IsVisible = inputContol.IsVisible ?? true;
        control.TextAfterInput = inputContol.TextAfterInput;
        control.IsNumber2Boolean = inputContol.IsNumber2Boolean;
        control.TemplateRef = inputContol.TemplateRef;
        control.Precision = inputContol.Precision;

        if (control.Width) {
          if (control.Width == 0)
            calculatedWidth = displayMaxWidth;
          else
            calculatedWidth = control.Width;

          if (calculatedWidth <= 25)
            calculatedWidth = 25;
          else
            calculatedWidth = displayMaxWidth;

          CalculatedWidthPct = maxWidthPct * (calculatedWidth / displayMaxWidth);
        }
        else {
          CalculatedWidthPct = maxWidthPct;

        }

        control.Style = 'width:' + CalculatedWidthPct.toFixed(0) + '% !important';

        Column.Name = control.Name;
        Column.DisplayName = control.DisplayName;
        Column.DomID = "F_" + control.DomID;
        Column.DataType = control.DataType;
        Column.IsEditable = control.IsEditable ?? false;
        Column.IsFilterable = control.IsFilterable ?? false;
        Column.Width = Math.min(((control.Width === null || control.Width === undefined) ? this.defaultColWidth : control.Width), maxColWidth) * this.charWidthinPixels;
        Column.controlType = (control.controlType == "checkbox" ? "boolean" : control.controlType == "number" ? "numeric" : control.controlType);
        Column.dropDownTemplate = control.dropDownTemplate;
        Column.lookupTemplate = control.lookupTemplate;
        Column.viewCellStyle = control.viewCellStyle ?? '';
        Column.Validators = control.Validators ?? null;
        Column.IsVisible = inputContol.ShowinOverviewGrid ?? false;
        Column.DefaultValue = control.DefaultValue ?? null;
        Column.ClickableText = inputContol.ClickableText;
        Column.ModalTitle = inputContol.ModalTitle;
        Column.checkboxTemplate = inputContol.checkboxTemplate;
        Column.imgs = inputContol.imgs;
        Column.removeNegativeTransform = FieldDetails.removeNegativeTransform;
        Column.ConditionalCellStyleFn = FieldDetails.ConditionalCellStyleFn;
        Column.Precision = inputContol.Precision;
        Column.LogImageTemplate = inputContol.LogImageTemplate;

        this.OverviewAndFromGroupColumns.push(Column);
      }
      else {
        //throw exception
        console.log("BIControls.AddControl --> Invalid field:" + inputContol.FieldName);

      }

    }
    if (inputContol.rowNumber !== 0) {
      if (!this.ControlList.find(x => x.Name == control.Name) == undefined)
        this.ControlList.push(control);
      this.groupedControlList.push({ group: inputContol.Group ?? '', Control: control });
    }
    this.BIControlList.push(inputContol);
  }
  public getAllControlList(): IControls[] {
    return this.ControlList;
  }
  public getControlListByGroup(Group: string): IControls[] {
    return this.groupedControlList.filter(Rec => {

      if (Group.toLowerCase() === Rec.group.toLowerCase())
        return true;
      else
        return false;
    }).map(Rec => { return Rec.Control });
  }
  public getOverviewAndFromGroupColumns(): IColumns[] {
    return this.OverviewAndFromGroupColumns;
  }

}

